import ApiService from "@/common/api.service";

export const GET_STOCK_DASHBOARD = "getStockDashboard";

const actions = {
  [GET_STOCK_DASHBOARD](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/dashboard", {
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  actions,
};
